import { ModelsGridView } from '~/components/catalog/models';
import { PageContainer } from '~/components/page-container';

export function Models() {
	return (
		<PageContainer>
			<ModelsGridView />
		</PageContainer>
	);
}
